export const featuredProducts = [
  {
    id: 1,
    name: 'Mezcla de Hierbas Orgánicas',
    description: 'Una mezcla aromática de hierbas frescas y orgánicas perfecta para ensaladas, sopas y platos mediterráneos.',
    price: '8,99',
    image: 'https://twidpdwinrndvvlujgij.supabase.co/storage/v1/object/public/content-images/solsazon-content-images/packs/pack-iniciacion-image.jpg',
    category: 'Mezclas',
    isNew: false,
    isOnSale: false,
    originalPrice: '',
    stock: 45,
    idealFor: 'ensaladas y sopas',
    tags: ['Orgánico', 'Sin gluten'],
  },
  {
    id: 2,
    name: 'Jengibre Molido Premium',
    description: 'Jengibre orgánico molido de alta calidad, ideal para marinadas, postres y platos asiáticos.',
    price: '6,99',
    image: 'https://twidpdwinrndvvlujgij.supabase.co/storage/v1/object/public/content-images/solsazon-content-images/packs/pack-iniciacion-image.jpg',
    category: 'Especias',
    isNew: false,
    isOnSale: true,
    originalPrice: '9,49',
    stock: 3,
    idealFor: 'marinadas y postres',
    tags: ['Orgánico', 'Picante'],
  },
  {
    id: 3,
    name: 'Set de Especias Indias',
    description: 'Colección de especias auténticas de la India incluyendo cúrcuma, comino, cilantro y más.',
    price: '12,99',
    image: 'https://twidpdwinrndvvlujgij.supabase.co/storage/v1/object/public/content-images/solsazon-content-images/packs/pack-iniciacion-image.jpg',
    category: 'Sets',
    isNew: false,
    isOnSale: true,
    originalPrice: '16,99',
    stock: 5,
    idealFor: 'curry y arroces',
    tags: ['Picante', 'Sin gluten'],
  },
  {
    id: 4,
    name: 'Albahaca Orgánica Seca',
    description: 'Hojas de albahaca orgánica cuidadosamente secadas para preservar su aroma y sabor intenso.',
    price: '5,49',
    image: 'https://twidpdwinrndvvlujgij.supabase.co/storage/v1/object/public/content-images/solsazon-content-images/packs/pack-iniciacion-image.jpg',
    category: 'Hierbas',
    isNew: false,
    isOnSale: false,
    originalPrice: '',
    stock: 32,
    idealFor: 'pasta y pizzas',
    tags: ['Orgánico', 'Sin sal'],
  },
  {
    id: 5,
    name: 'Pimienta Negra Premium',
    description: 'Granos enteros de pimienta negra orgánica con sabor robusto y aromático.',
    price: '7,99',
    image: 'https://twidpdwinrndvvlujgij.supabase.co/storage/v1/object/public/content-images/solsazon-content-images/packs/pack-iniciacion-image.jpg',
    category: 'Especias',
    isNew: false,
    isOnSale: false,
    originalPrice: '',
    stock: 28,
    idealFor: 'carnes y guisos',
    tags: ['Orgánico', 'Sin gluten'],
  },
  {
    id: 6,
    name: 'Set de Hierbas Mediterráneas',
    description: 'Colección de hierbas mediterráneas incluyendo romero, tomillo, orégano y lavanda.',
    price: '14,99',
    image: 'https://twidpdwinrndvvlujgij.supabase.co/storage/v1/object/public/content-images/solsazon-content-images/packs/pack-iniciacion-image.jpg',
    category: 'Sets',
    isNew: false,
    isOnSale: true,
    originalPrice: '19,99',
    stock: 2,
    idealFor: 'asados y verduras',
    tags: ['Orgánico', 'Sin sal'],
  },
  {
    id: 7,
    name: 'Cúrcuma Orgánica Molida',
    description: 'Cúrcuma pura de origen indio con alto contenido de curcumina, perfecta para currys y bebidas saludables.',
    price: '9,49',
    image: 'https://twidpdwinrndvvlujgij.supabase.co/storage/v1/object/public/content-images/solsazon-content-images/packs/pack-iniciacion-image.jpg',
    category: 'Especias',
    isNew: false,
    isOnSale: false,
    originalPrice: '',
    stock: 41,
    idealFor: 'curry y guisos',
    tags: ['Orgánico', 'Sin gluten', 'Sin sal'],
  },
  {
    id: 8,
    name: 'Canela de Ceilán Premium',
    description: 'Canela auténtica de Sri Lanka en rama, con aroma dulce y delicado ideal para postres y bebidas calientes.',
    price: '11,99',
    image: 'https://twidpdwinrndvvlujgij.supabase.co/storage/v1/object/public/content-images/solsazon-content-images/packs/pack-iniciacion-image.jpg',
    category: 'Especias',
    isNew: false,
    isOnSale: false,
    originalPrice: '',
    stock: 19,
    idealFor: 'postres y bebidas',
    tags: ['Orgánico', 'Sin gluten'],
  },
  {
    id: 9,
    name: 'Orégano Silvestre Griego',
    description: 'Orégano silvestre recolectado en las montañas de Grecia, con sabor intenso y aromático.',
    price: '6,49',
    image: 'https://twidpdwinrndvvlujgij.supabase.co/storage/v1/object/public/content-images/solsazon-content-images/packs/pack-iniciacion-image.jpg',
    category: 'Hierbas',
    isNew: false,
    isOnSale: false,
    originalPrice: '',
    stock: 37,
    idealFor: 'pizza y ensaladas',
    tags: ['Orgánico', 'Sin sal'],
  },
  {
    id: 10,
    name: 'Pimentón Ahumado de la Vera',
    description: 'Pimentón español ahumado con denominación de origen, perfecto para paellas y guisos tradicionales.',
    price: '8,49',
    image: 'https://twidpdwinrndvvlujgij.supabase.co/storage/v1/object/public/content-images/solsazon-content-images/packs/pack-iniciacion-image.jpg',
    category: 'Especias',
    isNew: false,
    isOnSale: true,
    originalPrice: '11,99',
    stock: 4,
    idealFor: 'paella y BBQ',
    tags: ['Sin gluten', 'Ahumado'],
  },
  {
    id: 11,
    name: 'Set de Especias para BBQ',
    description: 'Mezcla especial de especias ahumadas y picantes para carnes a la parrilla y barbacoas.',
    price: '13,99',
    image: 'https://twidpdwinrndvvlujgij.supabase.co/storage/v1/object/public/content-images/solsazon-content-images/packs/pack-iniciacion-image.jpg',
    category: 'Sets',
    isNew: false,
    isOnSale: false,
    originalPrice: '',
    stock: 22,
    idealFor: 'carnes y parrilla',
    tags: ['Ahumado', 'Picante'],
  },
  {
    id: 12,
    name: 'Romero Fresco Deshidratado',
    description: 'Romero orgánico deshidratado que conserva todo su aroma, ideal para carnes y patatas asadas.',
    price: '5,99',
    image: 'https://twidpdwinrndvvlujgij.supabase.co/storage/v1/object/public/content-images/solsazon-content-images/packs/pack-iniciacion-image.jpg',
    category: 'Hierbas',
    isNew: false,
    isOnSale: false,
    originalPrice: '',
    stock: 29,
    idealFor: 'asados y patatas',
    tags: ['Orgánico', 'Sin sal'],
  },
  {
    id: 13,
    name: 'Comino Molido Orgánico',
    description: 'Comino de primera calidad con aroma terroso y cálido, esencial en la cocina mexicana y árabe.',
    price: '4,99',
    image: 'https://twidpdwinrndvvlujgij.supabase.co/storage/v1/object/public/content-images/solsazon-content-images/packs/pack-iniciacion-image.jpg',
    category: 'Especias',
    isNew: false,
    isOnSale: false,
    originalPrice: '',
    stock: 50,
    idealFor: 'tacos y hummus',
    tags: ['Orgánico', 'Sin gluten', 'Sin sal'],
  },
  {
    id: 14,
    name: 'Mezcla Garam Masala',
    description: 'Auténtica mezcla india de especias tostadas incluyendo cardamomo, clavo, canela y nuez moscada.',
    price: '10,99',
    image: 'https://twidpdwinrndvvlujgij.supabase.co/storage/v1/object/public/content-images/solsazon-content-images/packs/pack-iniciacion-image.jpg',
    category: 'Mezclas',
    isNew: false,
    isOnSale: false,
    originalPrice: '',
    stock: 18,
    idealFor: 'curry y arroces',
    tags: ['Picante', 'Sin gluten'],
  },
  {
    id: 15,
    name: 'Tomillo Limón Orgánico',
    description: 'Variedad especial de tomillo con notas cítricas, perfecto para pescados y aves.',
    price: '6,99',
    image: 'https://twidpdwinrndvvlujgij.supabase.co/storage/v1/object/public/content-images/solsazon-content-images/packs/pack-iniciacion-image.jpg',
    category: 'Hierbas',
    isNew: true,
    isOnSale: false,
    originalPrice: '',
    stock: 24,
    idealFor: 'pescado y pollo',
    tags: ['Orgánico', 'Sin sal'],
  },
  {
    id: 16,
    name: 'Set de Especias Marroquíes',
    description: "Colección de especias del norte de África incluyendo ras el hanout, harissa y za'atar.",
    price: '16,99',
    image: 'https://twidpdwinrndvvlujgij.supabase.co/storage/v1/object/public/content-images/solsazon-content-images/packs/pack-iniciacion-image.jpg',
    category: 'Sets',
    isNew: true,
    isOnSale: false,
    originalPrice: '',
    stock: 15,
    idealFor: 'tagines y cuscús',
    tags: ['Picante', 'Sin gluten'],
  },
  {
    id: 17,
    name: 'Cardamomo Verde Premium',
    description: 'Vainas de cardamomo verde enteras con aroma floral intenso, ideal para postres y mezclas especiadas.',
    price: '14,49',
    image: 'https://twidpdwinrndvvlujgij.supabase.co/storage/v1/object/public/content-images/solsazon-content-images/packs/pack-iniciacion-image.jpg',
    category: 'Especias',
    isNew: true,
    isOnSale: false,
    originalPrice: '',
    stock: 12,
    idealFor: 'postres y mezclas',
    tags: ['Orgánico', 'Sin gluten'],
  },
  {
    id: 18,
    name: 'Mezcla Hierbas Provenzales',
    description: 'Blend tradicional francés con lavanda, tomillo, romero, mejorana y ajedrea.',
    price: '9,99',
    image: 'https://twidpdwinrndvvlujgij.supabase.co/storage/v1/object/public/content-images/solsazon-content-images/packs/pack-iniciacion-image.jpg',
    category: 'Mezclas',
    isNew: true,
    isOnSale: false,
    originalPrice: '',
    stock: 21,
    idealFor: 'asados y verduras',
    tags: ['Orgánico', 'Sin sal'],
  },
  {
    id: 19,
    name: 'Azafrán Español La Mancha',
    description: 'Hebras de azafrán puro con denominación de origen La Mancha, el oro rojo de la cocina española.',
    price: '18,99',
    image: 'https://twidpdwinrndvvlujgij.supabase.co/storage/v1/object/public/content-images/solsazon-content-images/packs/pack-iniciacion-image.jpg',
    category: 'Especias',
    isNew: true,
    isOnSale: false,
    originalPrice: '',
    stock: 8,
    idealFor: 'paella y risotto',
    tags: ['Premium', 'Sin gluten'],
  },
  {
    id: 20,
    name: 'Mezcla Chimichurri Argentino',
    description: 'Auténtica mezcla de hierbas y especias para preparar el clásico chimichurri argentino.',
    price: '7,99',
    image: 'https://twidpdwinrndvvlujgij.supabase.co/storage/v1/object/public/content-images/solsazon-content-images/packs/pack-iniciacion-image.jpg',
    category: 'Mezclas',
    isNew: true,
    isOnSale: true,
    originalPrice: '10,99',
    stock: 3,
    idealFor: 'carnes y BBQ',
    tags: ['Sin gluten', 'Sin sal'],
  },
  {
    id: 21,
    name: 'Vainilla Bourbon de Madagascar',
    description: 'Vainas de vainilla bourbon premium de Madagascar, con aroma dulce y cremoso incomparable.',
    price: '12,49',
    image: 'https://twidpdwinrndvvlujgij.supabase.co/storage/v1/object/public/content-images/solsazon-content-images/packs/pack-iniciacion-image.jpg',
    category: 'Especias',
    isNew: true,
    isOnSale: false,
    originalPrice: '',
    stock: 14,
    idealFor: 'postres y repostería',
    tags: ['Premium', 'Sin gluten'],
  },
  {
    id: 22,
    name: 'Set Especias Asiáticas Fusión',
    description: 'Colección de especias orientales con jengibre, lemongrass, anís estrellado y cinco especias chinas.',
    price: '15,49',
    image: 'https://twidpdwinrndvvlujgij.supabase.co/storage/v1/object/public/content-images/solsazon-content-images/packs/pack-iniciacion-image.jpg',
    category: 'Sets',
    isNew: true,
    isOnSale: true,
    originalPrice: '19,99',
    stock: 2,
    idealFor: 'wok y stir-fry',
    tags: ['Picante', 'Sin gluten'],
  },
  {
    id: 23,
    name: 'Menta Piperita Orgánica',
    description: 'Hojas de menta piperita deshidratadas con intenso aroma refrescante, ideal para infusiones y postres.',
    price: '4,99',
    image: 'https://twidpdwinrndvvlujgij.supabase.co/storage/v1/object/public/content-images/solsazon-content-images/packs/pack-iniciacion-image.jpg',
    category: 'Hierbas',
    isNew: false,
    isOnSale: true,
    originalPrice: '7,49',
    stock: 5,
    idealFor: 'infusiones y postres',
    tags: ['Orgánico', 'Sin sal'],
  },
  {
    id: 24,
    name: 'Mezcla Dukkah Egipcia',
    description: 'Tradicional mezcla egipcia de frutos secos, semillas y especias tostadas para mojar con pan y aceite.',
    price: '11,49',
    image: 'https://twidpdwinrndvvlujgij.supabase.co/storage/v1/object/public/content-images/solsazon-content-images/packs/pack-iniciacion-image.jpg',
    category: 'Mezclas',
    isNew: true,
    isOnSale: false,
    originalPrice: '',
    stock: 17,
    idealFor: 'aperitivos y ensaladas',
    tags: ['Sin gluten', 'Sin sal'],
  },
  {
    id: 25,
    name: "Mezcla Za'atar Levantino",
    description: "Auténtico za'atar del Levante con tomillo silvestre, zúmaque, sésamo y sal marina. Ideal para pan, hummus y carnes.",
    price: '8,99',
    image: 'https://twidpdwinrndvvlujgij.supabase.co/storage/v1/object/public/content-images/solsazon-content-images/packs/pack-iniciacion-image.jpg',
    category: 'Mezclas',
    isNew: true,
    isOnSale: false,
    originalPrice: '',
    stock: 30,
    idealFor: 'pan, hummus y carnes',
    tags: ['Sin gluten', 'Orgánico'],
  },
  {
    id: 26,
    name: 'Mezcla Chai de Especias',
    description: 'Blend artesanal de especias para chai: canela, cardamomo, jengibre, clavo y pimienta negra. Solo especias puras, sin té.',
    price: '9,49',
    image: 'https://twidpdwinrndvvlujgij.supabase.co/storage/v1/object/public/content-images/solsazon-content-images/packs/pack-iniciacion-image.jpg',
    category: 'Mezclas',
    isNew: false,
    isOnSale: true,
    originalPrice: '12,99',
    stock: 34,
    idealFor: 'bebidas calientes y postres',
    tags: ['Picante', 'Sin gluten'],
  },
  {
    id: 27,
    name: 'Pimienta de Sichuan',
    description: 'Pimienta de Sichuan entera con su característico efecto entumecedor y notas cítricas. Imprescindible en la cocina china.',
    price: '12,99',
    image: 'https://twidpdwinrndvvlujgij.supabase.co/storage/v1/object/public/content-images/solsazon-content-images/packs/pack-iniciacion-image.jpg',
    category: 'Especias',
    isNew: true,
    isOnSale: false,
    originalPrice: '',
    stock: 22,
    idealFor: 'cocina china y fusión',
    tags: ['Picante', 'Sin gluten', 'Premium'],
  },
  {
    id: 28,
    name: 'Mezcla Ras el Hanout Premium',
    description: 'Auténtica mezcla marroquí de más de 12 especias: cúrcuma, comino, cilantro, canela, jengibre, pimienta y más.',
    price: '11,49',
    image: 'https://twidpdwinrndvvlujgij.supabase.co/storage/v1/object/public/content-images/solsazon-content-images/packs/pack-iniciacion-image.jpg',
    category: 'Mezclas',
    isNew: false,
    isOnSale: false,
    originalPrice: '',
    stock: 26,
    idealFor: 'tagines y cuscús',
    tags: ['Orgánico', 'Sin gluten', 'Sin sal'],
  },
  {
    id: 29,
    name: 'Semillas de Sésamo Tostado',
    description: 'Sésamo blanco tostado artesanalmente, ideal para aderezar ensaladas, arroces y platos orientales.',
    price: '5,49',
    image: 'https://twidpdwinrndvvlujgij.supabase.co/storage/v1/object/public/content-images/solsazon-content-images/packs/pack-iniciacion-image.jpg',
    category: 'Semillas',
    isNew: false,
    isOnSale: false,
    originalPrice: '',
    stock: 50,
    idealFor: 'ensaladas y arroces',
    tags: ['Orgánico', 'Sin gluten', 'Sin sal'],
  },
  {
    id: 30,
    name: 'Semillas de Hinojo Orgánico',
    description: 'Semillas de hinojo enteras con aroma anisado y fresco, perfectas para embutidos, panes y salsas mediterráneas.',
    price: '4,99',
    image: 'https://twidpdwinrndvvlujgij.supabase.co/storage/v1/object/public/content-images/solsazon-content-images/packs/pack-iniciacion-image.jpg',
    category: 'Semillas',
    isNew: true,
    isOnSale: false,
    originalPrice: '',
    stock: 38,
    idealFor: 'panes y embutidos',
    tags: ['Orgánico', 'Sin gluten', 'Sin sal'],
  },
  {
    id: 31,
    name: 'Clavo de Olor Entero',
    description: 'Clavos de olor enteros de alta calidad con aroma intenso y cálido, esenciales en repostería y guisos especiados.',
    price: '7,49',
    image: 'https://twidpdwinrndvvlujgij.supabase.co/storage/v1/object/public/content-images/solsazon-content-images/packs/pack-iniciacion-image.jpg',
    category: 'Especias',
    isNew: false,
    isOnSale: false,
    originalPrice: '',
    stock: 33,
    idealFor: 'repostería y guisos',
    tags: ['Orgánico', 'Sin gluten', 'Premium'],
  },
  {
    id: 32,
    name: 'Anís Estrellado Orgánico',
    description: 'Anís estrellado entero de origen vietnamita, con aroma dulce e intenso. Perfecto para caldos, marinadas y repostería.',
    price: '8,49',
    image: 'https://twidpdwinrndvvlujgij.supabase.co/storage/v1/object/public/content-images/solsazon-content-images/packs/pack-iniciacion-image.jpg',
    category: 'Especias',
    isNew: false,
    isOnSale: true,
    originalPrice: '11,49',
    stock: 28,
    idealFor: 'caldos y marinadas',
    tags: ['Orgánico', 'Sin gluten', 'Sin sal'],
  },
];
